import { ProjectDetails } from "../../Models/ProjectDetails";
import { ProjectFormData } from "../../Models/ProjectFormData";
import { RestApiResponse } from "../../Models/RestApiResponse";
import { getProjectAsync } from "../../Services/ProjectsService";
import {getProjectError, getProjectLoading, getProjectSuccess, getProjectLicenses} from "./ProjectModalActions";
import { Logo } from "../../Models/Logo";
import { notAuthorised } from "../UserAuth/UserAuthActions";
import { License } from "../../Models/License";
import { LicenseGroup } from "../../Models/LicenseGroup";
import { getProjectLicenses as projectLicenses } from "../../Services/LicensesService";
import { getDealersForUser } from "../../Services/DealerAdminService";
import { Dealer } from "../../Models/Dealer";
import { DataConnections } from "../../Models/Interface";
import { ProjectDailyJob } from "../../Models/ProjectDailyJobs";

export const getProjectDetailsForModal = (projectId: number) => (dispatch: any) => {
    dispatch(getProjectLoading());
    getProjectAsync(projectId).then((response: RestApiResponse) => {
        if (response.statusCode === 401) {
            dispatch(notAuthorised());
        }
        if (response.success) {
            const data = response.data as ProjectDetails;
            const modalData: ProjectFormData = {
                dealerProjectId: data.dealerProjectId,
                projectName: data.name,
                country: data.country,
                language: data.defaultlanguage,
                description: data.description,
                dealerIds: data.dealerIds,
                customer: data.customer,
                timeZone: data.timeoffset,
                dateformat: data.dateformat,
                vendor: data.vendor,
                seasonStart: data.seasonStartDate,
                preSeason: data.mainSeason,
                seasonEnd: data.seasonEndDate,
                epsgCode: data.coordinatereferencesystem,
                unit: data.unit || 0,
                modeModelError: data.modeModelError || 0,
                logo: data.logo ?? ({} as Logo),
                settings: data.settings,
                dailyJobs: data.dailyjobs
            };

            dispatch(getProjectSuccess(modalData, data.apps, updateCronExpressions(data.dailyjobs, data.timeoffset), data.dataconnections));
            getLicenses(modalData.projectName)(dispatch);
        } else {
            const errorCode = response.errorCode ? response.errorCode : "GetProjectError";
            dispatch(getProjectError(errorCode));
        }
    });
};

export const getEmptyProjectData = () => (dispatch: any) => {
    dispatch(getProjectLoading());
    const modalData: ProjectFormData = {
        dealerProjectId: undefined,
        projectName: "",
        country: "",
        language: "",
        description: "",
        dealerIds: [],
        customer: "",
        timeZone: 0,
        dateformat: "dd.MM.yyyy HH:mm",
        vendor: "",
        seasonStart: undefined,
        preSeason: undefined,
        seasonEnd: undefined,
        epsgCode: undefined,
        unit: 0,
        modeModelError: 0,
        logo: {} as Logo,
        dailyJobs: [
        {
            id: 0,
            name: "Import Snow data (daily)",
            type: 9,
            cronexpression: "0 0 6 ? * *",
            duration: 1
        },
        {
          id: 0,
          name: "Import Vehicle Tracking Data (ConX)",
          type: 12,
          cronexpression: "0 55 */4 * * ?",
          duration: 1
        }]
    };

    getDealersForUser().then((response: RestApiResponse) => {
        if (response.success) {
            const data = response.data as Dealer[];
            modalData.dealerIds = data.map((d) => d.id);
        }
        const dataconnections: DataConnections = {snowheightdataproviders: [], vehicletrackingdataproviders: [], snowmakingdataproviders: [], datareceivers: [], projecttoken: "", projectinterfacetoken: "", projectapiurl: ""}
        const dailyjobs: ProjectDailyJob[] = []
        dispatch(getProjectSuccess(modalData, [], dailyjobs, dataconnections));
    });
};

const groupLicensesByKey = (licenses: License[]) => {
    var items: LicenseGroup = {};

    return licenses.reduce((result, license, index) => ({
        ...result,
        [license.licensekey]: [...(result[license.licensekey] || []), license],
    }),
    items);
};

export const getLicenses = (projectName: string) => (dispatch: any) => {
    projectLicenses(projectName).then((response: RestApiResponse) => {
        if (response.statusCode === 401) {
            dispatch(notAuthorised());
        }
        if (response.success) {
            const licenses = response.data as License[];
            if (licenses) {
                var grouped = groupLicensesByKey(licenses);
                dispatch(getProjectLicenses(grouped));
            }
        }
    });
};

const updateCronExpressions = (dailyJobs: ProjectDailyJob[], timeOffset: number): ProjectDailyJob[] => {
    if (dailyJobs != undefined) {
        return dailyJobs.map(job => {
            if (timeOffset != undefined) {
                // Split the cron expression into its components
                const cronParts = job.cronexpression.split(" ");
                
                if (cronParts.length < 5) {
                    console.error(`Invalid cron expression for job: ${job.name}`);
                    return job; // Return the job as is if the cron expression is invalid
                }

                // Parse the hour part (second part of cron expression)
                let hour = parseInt(cronParts[2]);

                if (!isNaN(hour)) {
                    // Add 2 hours, and handle wrap-around for 24-hour format
                    hour = (hour + timeOffset) % 24;

                    // Update the cron expression with the new hour
                    cronParts[2] = hour.toString();
                }

                // Join the cron parts back together into a valid cron expression
                job.cronexpression = cronParts.join(" ");
            }

            // Return the modified job
            return job;
        });
    }

    return [];
};
